export default __webpack_public_path__ + "static/why-choose-0253f1ff0de32416711559a0d6ecc424.webp";